// src/utils/searchOffers.js

import { Actions } from '../../client/Actions';

export const searchOffers = ({
  params,
  setLoader,
  setResult,
  houseId,
  reservationId,
  payment,
  manualDiscounts,
  manualAdditionalPayments,
}) => {
  if (!params) {
    return;
  }

  const { startDate, endDate, adults, children, infants } = params;

  // WALIDACJA: jeśli brakuje wymaganych pól, NIC nie robimy
  if (
    !startDate ||
    !endDate ||
    (adults == null && children == null && infants == null)
  ) {
    return;
  }

  setLoader(true);

  const req = {
    startDate,
    endDate,
    reservationId: reservationId,
    guests: {
      adults,
      children,
      infants,
    },
    manualDiscounts,
    manualAdditionalPayments,
    payment: {
      securityDepositAmount: payment?.securityDepositAmount,
      paymentModel: payment?.paymentModel,
      ...(payment?.paymentModel === 'PARTIAL_PAYMENT' && {
        paymentOnBookingPercentage: payment?.paymentOnBookingPercentage,
      }),
    },
  };


  const url = houseId ? `house-offer/${houseId}` : 'house-offer';

  Actions.post(url, req, (response) => {
    setLoader(false);

    setResult({
      searchParams: params,
      result: response,
    });
  }, undefined, undefined, undefined, true);
};
